var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.666 8a6.665 6.665 0 1 1-13.33.001 6.665 6.665 0 0 1 13.33 0m-7.585.396-3.186-4.26H6.35L8.44 6.93l2.585-2.792h.721L8.761 7.36l3.366 4.5H9.67L7.403 8.827 4.597 11.86h-.722zm-.997-3.728H4.956l4.981 6.66h1.128z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitter;